import React from 'react';
import '../../scss/Loading.css'

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="loader">
                <div className="spinner"></div>
                <div className="loader-text">Loading...</div>
            </div>
        </div>
    );
};

export default Loader;
